import {Component, HostListener, inject, Input, OnInit, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';
import {BaseComponent, WmsDialogComponent} from "@wms/components";
import {DialogService, NotificationService, PreferenceService, StudioService, UserService} from "@wms/services";
import {AppRef} from "@wms/design-container";
import { find } from "lodash-es";
import {UserAvatarComponent} from "@wms/app/user-avatar/user-avatar.component";
import {BsDropdownDirective, BsDropdownModule} from "ngx-bootstrap/dropdown";
import {ROUTE_CONSTANTS, StudioUtils, VersionManagerPipe} from "@wms/core";
import {AboutDialogComponent} from "@wms/app/about-dialog/about-dialog.component";
import {WmsFeatureDirective} from "@wms/directives";




@Component({
  selector: 'wms-studio-user-info',
  standalone: true,
  imports: [CommonModule, UserAvatarComponent, BsDropdownModule, WmsDialogComponent, AboutDialogComponent, WmsFeatureDirective, VersionManagerPipe],
  templateUrl: './studio-user-info.component.html',
  styleUrls: ['./studio-user-info.component.less']
})


export class StudioUserInfoComponent extends  BaseComponent implements OnInit {
  @ViewChild('dropdown') dropdown: BsDropdownDirective;
  selectedOrganization: any;
  user: any;
  displayName: string;
  selfOrg: any;
  project: any;
  organizations: any;
  subscriptionDetails: any;
  appRef: AppRef;
  dialogService: DialogService;
  studioPreferences: PreferenceService;
  notificationService: NotificationService;
  studioInfo:any;


  constructor(private userService: UserService,
              private studioService: StudioService) {
    super();
    this.appRef = inject(AppRef);
    this.studioPreferences = inject(PreferenceService);
    this.dialogService = inject(DialogService)
    this.notificationService = inject(NotificationService);
    this.project = this.projectService.getDetails()
    this.user = this.userService.get()

  }

  @HostListener('document:keydown', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.dropdown.isOpen) {
      this.dropdown.isOpen = false;
    }
  }

  ngOnInit() {
      this.studioService.getSelectedOrganization().then((res)=>{
        this.selectedOrganization =  res
        this.selfOrg = find(this.studioService.organizationList, org => org.mode === 'OWN');
      })
    this.studioService.getStudioInfo().then((responce)=>{
      this.studioInfo = responce
    })
    if (this.user) {
      this.user.email = this.user.emailAddress || this.user.email;
      this.displayName = this.user.displayName || this.user.firstName;
    }
  }


  switchOrganization(org: any) {
  }

  openAboutDialog() {
    this.dialogService.open('aboutDialog')
  }

  resendVerificationEmail() {
    this.userService.resendVerificationEmail().then(res => {
      this.notificationService.show('success', this.locale["MESSAGE_SUCCESS_TITLE"], this.locale["MESSAGE_RESEND_EMAIL_SUCCESS"]);
    }, errMsg => {
      this.notificationService.show('error', this.locale["MESSAGE_ERROR_TITLE"], errMsg);
    });
  }

  goToProfile() {
    StudioUtils.redirectToIndexPage(ROUTE_CONSTANTS.USER_PROFILE_DEFAULT);
  };

  //
  goToAccount() {
    if (this.studioPreferences.hasAccess('workspace.subscriptions')) {
      window.open(ROUTE_CONSTANTS.SUBSCRIPTIONS);
    } else {
      StudioUtils.redirectToIndexPage(ROUTE_CONSTANTS.ACCOUNTS);
    }
  };

  closeDialogWithId(id:string){
    this.dialogService.close(id)
  }

  /*logout from studio*/
  logout() {
    this.userService.logout().then(() => {
      if (this.studioPreferences.hasAccess('workspace.redirectToCloudLoginPage')) {
        window.location.href = "/login/signout";
      } else {
        StudioUtils.redirectToLoginPage();
      }
    })
  };
}

